import { useMemo } from "react";
import { Navigate, useParams, useSearchParams } from "react-router-dom";
import paths from "paths";
import { useStateContext } from "state";
import { AccountIntegratedDashboardPage } from "./account-integrated-dashboard.page";

/**
 * Entry for `/accounts/:id` and `/accounts/:id/dashboard`.
 * Canonical adhoc URLs use `/adhoc_report/:contextId` (or project reports route).
 * Legacy `?ctx=` on dashboard redirects there for adhoc accounts (REXDEV-660).
 */
export function AccountDashboardPage() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const ctx = searchParams.get("ctx");
  const { user } = useStateContext();

  const role = useMemo(
    () => user?.roles.find((r) => r.accountNumber === id),
    [user, id],
  );

  if (!id) return null;

  if (ctx && !user) {
    return null;
  }

  if (ctx && role?.isAdhoc) {
    return (
      <Navigate
        replace
        to={`/${paths.authenticated.USER_ACCOUNTS}/${id}/${paths.authenticated.ADHOC_REPORT}/${ctx}`}
      />
    );
  }

  return <AccountIntegratedDashboardPage />;
}
